import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

/** Часть OperationResult, нужная форме: коды ошибок и ошибки по путям полей. */
export interface ServerOutcome {
  success: boolean;
  messages: readonly string[];
  fieldErrors?: Record<string, string>;
}

/** Ключ общей ошибки формы в formState.errors.root. */
export const SERVER_ERROR = 'server';

/**
 * Раскладывает неудачный ответ сервера по форме (SYS-UC-12): ошибки полей, чей первый сегмент
 * пути есть в fields, встают к полям («fields.0» → строка 0 списка fields); остальные коды —
 * общей ошибкой формы. Возвращает true, если ошибок не было.
 */
export function applyServerErrors<T extends FieldValues>(setError: UseFormSetError<T>, outcome: ServerOutcome, fields: readonly string[]): boolean {
  if (outcome.success) return true;
  const known = new Set(fields);
  let shownAtField = false;
  for (const [path, code] of Object.entries(outcome.fieldErrors ?? {})) {
    const head = path.split('.')[0] ?? '';
    if (known.has(head)) {
      setError(path as Path<T>, { type: SERVER_ERROR, message: code });
      shownAtField = true;
    }
  }
  if (!shownAtField || hasErrorsOutside(outcome, known)) {
    setError(`root.${SERVER_ERROR}`, { type: SERVER_ERROR, message: outcome.messages[0] ?? 'INTERNAL_ERROR' });
  }
  return false;
}

/** Ошибка пришла к полю, которого в форме нет: её всё равно надо показать — общей. */
function hasErrorsOutside(outcome: ServerOutcome, known: ReadonlySet<string>): boolean {
  return Object.keys(outcome.fieldErrors ?? {}).some((path) => !known.has(path.split('.')[0] ?? ''));
}
